import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface RegisteredTenantWarningDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  roomDetailPath: string | null
}

export function RegisteredTenantWarningDialog({
  open,
  onOpenChange,
  roomDetailPath,
}: RegisteredTenantWarningDialogProps) {
  const navigate = useNavigate()

  const handleGoToRoomDetail = () => {
    if (!roomDetailPath) return
    onOpenChange(false)
    navigate(roomDetailPath)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[420px] rounded-lg p-6">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold text-slate-900">
            登録済みの賃借人が存在します
          </DialogTitle>
          <DialogDescription className="pt-2 text-left text-sm leading-6 text-slate-600">
            この部屋には現在有効な賃借人、または次の賃借人が登録されています。
            <br />
            新しい契約者を承認してプランに加入する場合は、先に部屋詳細画面で賃借人情報とプラン状況を確認してください。
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="pt-2">
          <Button onClick={handleGoToRoomDetail} disabled={!roomDetailPath}>
            部屋詳細ページへ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
